/* eslint-disable */
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AdminBlog<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  list = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminBlog/List`, method: "GET", secure: true, ...params });
  detail = (id: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminBlog/Detail/${id}`, method: "GET", secure: true, ...params });
  create = (data: any, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminBlog`, method: "POST", body: data, secure: true, type: ContentType.Json, ...params });
  update = (id: string, data: any, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminBlog/${id}`, method: "PUT", body: data, secure: true, type: ContentType.Json, ...params });
  remove = (id: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminBlog/${id}`, method: "DELETE", secure: true, ...params });
}
